module.exports = __webpack_public_path__ + "static/media/DEFAULT.d4b45420.jpeg";